class KeywordBlock {
  constructor () {
    this.$container = $('.keywords-content');
    this.$toggle = $('.keywords-click');
    this.$toggle.on('click', () => {
      if( this.$container.is(':hidden') ) this.show();
      else this.hide();
    });
  }
  show() {
    this.$container.slideDown("slow");
    this.$toggle.find('.collapse-arrow').addClass('active');
  }
  hide() {
    this.$container.slideUp("slow");
    this.$toggle.find('.collapse-arrow').removeClass('active');
  }
}

export default function CASE() {
  $(() => {
    let keywordBlock = new KeywordBlock();
    // 初期は非表示
    keywordBlock.hide();
  });

}
